// Malagasy translations
export const mg: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Mpanjifa',
  'menu.products': 'Vokatra',
  'menu.users': 'Mpampiasa',
  'menu.settings': 'Fandrindrana',
  'menu.logout': 'Hivoaka',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Baiko Vaovao',
  'order.title': 'Baiko Vaovao',
  'order.customer': 'Mpanjifa',
  'order.products': 'Vokatra',
  "order.total": "Totalin'ny",
  'users.title': 'Mpampiasa',
  'users.name': 'Anarana',
  'users.email': 'Mailaka',
  'common.yes': 'Eny',
  'common.no': 'Tsia',
  'common.cancel': 'Aoka ihany',
  'common.save': 'Tehirizina',
  'common.search': 'Karohy',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Hiditra',
  'login.welcome': 'Tonga soa, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Mailaka',
  'signup.phone': 'Telefaonina',
  'menu.reportsAndAccounting': 'Tatitra sy Kaonty',
  'menu.systemAndCommunication': 'Rafitra sy Fifandraisana',
};